<ion-row class="th-text" [ngClass]="{ 'align-header-right': rightAlign }">
  {{ header }}
</ion-row>
<ion-row
  class="dropdown-search-wrapper"
  [ngClass]="{ 'align-header-right': rightAlign }"
>
  <div class="checkbox-search" [ngClass]="dropdownWidthClass">
    @if (showTooltip) {
      <div
        class="custom-filter-container"
        onkeypress="updateDropdown()"
        #tooltip="matTooltip"
        [matTooltip]="toolTipText"
        [matTooltipPosition]="'right'"
        (click)="updateDropdown()"
      >
        @if (!operationsIcons) {
          <span class="selected-icon">
            @switch (displayedData) {
              @case (ImageOptions.ALL_SELECTED) {
                <div>
                  {{ displayedData }}
                </div>
              }
              @case (ImageOptions.ACTIVE) {
                <img class="icon" [src]="Images.ACTIVE" alt="active" />
              }
              @case (ImageOptions.SUSPENDED) {
                <img class="icon" [src]="Images.YIELD" alt="yield" />
              }
              @case (ImageOptions.DEACTIVATED) {
                <img class="icon" [src]="Images.CANCEL" alt="cancel" />
              }
              @default {
                <div class="dropdown-text">{{ displayedData }}</div>
              }
            }
          </span>
        }
        @if (operationsIcons) {
          <span class="selected-icon">
            @switch (displayedData) {
              @case (StopTypeImageOptions.ALL_SELECTED) {
                <div>
                  {{ displayedData }}
                </div>
              }
              @case (StopTypeImageOptions.ON_DEMAND) {
                <img class="icon" [src]="Images.PHONE" alt="active" />
              }
              @case (StopTypeImageOptions.SCHEDULED) {
                <img class="icon" [src]="Images.PICKUP" alt="yield" />
              }
              @default {
                <div class="dropdown-text">{{ displayedData }}</div>
              }
            }
          </span>
        }
        <img [src]="Images.CHEVRON" alt="search" />
      </div>
    }
    @if (!showTooltip) {
      <div
        class="custom-filter-container"
        onkeypress="updateDropdown()"
        (click)="updateDropdown()"
      >
        @if (!operationsIcons) {
          <span class="selected-icon">
            @switch (displayedData) {
              @case (ImageOptions.ALL_SELECTED) {
                <div>
                  {{ displayedData }}
                </div>
              }
              @case (ImageOptions.ACTIVE) {
                <img class="icon" [src]="Images.ACTIVE" alt="active" />
              }
              @case (ImageOptions.SUSPENDED) {
                <img class="icon" [src]="Images.YIELD" alt="yield" />
              }
              @case (ImageOptions.DEACTIVATED) {
                <img class="icon" [src]="Images.CANCEL" alt="cancel" />
              }
              @default {
                <div class="dropdown-text">{{ displayedData }}</div>
              }
            }
          </span>
        }
        @if (operationsIcons) {
          <span class="selected-icon">
            @switch (displayedData) {
              @case (StopTypeImageOptions.ALL_SELECTED) {
                <div>
                  {{ displayedData }}
                </div>
              }
              @case (StopTypeImageOptions.ON_DEMAND) {
                <img class="icon" [src]="Images.PHONE" alt="active" />
              }
              @case (StopTypeImageOptions.SCHEDULED) {
                <img class="icon" [src]="Images.PICKUP" alt="yield" />
              }
              @default {
                <div class="dropdown-text">{{ displayedData }}</div>
              }
            }
          </span>
        }
        <img [src]="Images.CHEVRON" alt="search" />
      </div>
    }
    @if (showDropdown && !operationsIcons) {
      <div class="search-results">
        <ion-item-group
          class="item-group"
          [ngClass]="dropdownWidthClass"
        >
          <ion-item
            lines="none"
            onkeypress="onAllSelect()"
            (click)="onAllSelect()"
          >
            <ion-checkbox
              class="checkbox dropdown-text"
              labelPlacement="end"
              justify="start"
              slot="start"
              [(ngModel)]="allOptionsSelected"
            >
              <div>
                {{ SELECT_ALL }}
              </div>
            </ion-checkbox>
          </ion-item>
          @for (status of statusOptions; track status) {
            <ion-item
              lines="none"
              #tooltip="matTooltip"
              [matTooltip]="status.id"
              [matTooltipPosition]="'right'"
              onkeypress="statusChange()"
              (click)="statusChange()"
            >
              <ion-checkbox slot="start" [(ngModel)]="status.selected">
              </ion-checkbox>
              <img [src]="status.src" alt="status" />
            </ion-item>
          }
        </ion-item-group>
      </div>
    }
    @if (showDropdown && operationsIcons) {
      <div class="search-results">
        <ion-item-group
          class="item-group"
          [ngClass]="dropdownWidthClass"
        >
          <ion-item
            lines="none"
            onkeypress="onAllSelect()"
            (click)="onAllSelect()"
          >
            <ion-checkbox
              class="checkbox dropdown-text"
              labelPlacement="end"
              justify="start"
              slot="start"
              [(ngModel)]="allOptionsSelected"
            >
              <div>
                {{ SELECT_ALL }}
              </div>
            </ion-checkbox>
          </ion-item>
          @for (stopType of stopTypeOptions; track stopType) {
            <ion-item
              lines="none"
              onkeypress="statusChange()"
              (click)="statusChange()"
            >
              <ion-checkbox slot="start" [(ngModel)]="stopType.selected">
              </ion-checkbox>
              <img
                [src]="stopType.src"
                alt="stopType"
                #tooltip="matTooltip"
                [matTooltip]="stopType.id"
                [matTooltipPosition]="'right'"
              />
            </ion-item>
          }
        </ion-item-group>
      </div>
    }
  </div>
</ion-row>
